import { getApiHandles } from 'reduxes/slices/api/selectors'
import { createSelector } from 'reselect'

export const makeIsATeammateOnline = () =>
  createSelector(
    [getApiHandles, (_, props) => props.handles],
    (handleModels, handles) => {
      for (let i = 0; i < handles.length; i++) {
        const handle = handles[i]
        const handleRecord = handleModels[handle]
        if (handleRecord?.online) {
          return handleRecord?.away ? 'away' : 'online'
        }
      }
      return 'offline'
    },
  )

export const makeIsSpecificTeammateOnline = () =>
  createSelector(
    [getApiHandles, (_, props) => props.handle],
    (handleModels, handle) => {
      const handleRecord = handleModels[handle]
      if (handleRecord?.online) {
        return handleRecord?.away ? 'away' : 'online'
      }

      return 'offline'
    },
  )
